import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import AuthView from "@/app/views/auth/authView.vue";
import LoginComponent from "@/app/views/auth/components/login/login.component.vue";
import ForgotPasswordComponent from "@/app/views/auth/components/forgotPassword/forgotPassword.component.vue";
import RegisterComponent from "@/app/views/auth/components/register/register.component.vue";
import PinAcessComponent from "@/app/views/auth/components/pinAccess/pinAccess.component.vue";
import PinLoginComponent from "@/app/views/auth/components/pinAccess/pinLogin.component.vue";
import AdminView from "@/app/admin/adminView.vue";
import {
  ROLE_ADMIN,
  ROLE_STUDENT,
  ROLE_SUPER_ADMIN,
  ROLE_TEACHER,
  ROLE_USER,
} from "@/resources/constants/roles";
import NubiiView from "@/app/views/nubii/nubiiView.vue";
import ResetPasswordComponent from "@/app/views/auth/components/resetPassword/resetPassword.component.vue";
import ActiveSpaceView from "@/app/views/activeSpace/activeSpaceView.vue";
import ConfirmInvitationView from "@/app/views/confirmInvitation/confirmInvitationView.vue";
import ActivateUser from "@/app/views/confirmInvitation/activateUser.vue";
import ChromeExclusiveComponent from "@/app/views/chromeExclusive/chromeExclusive.component.vue";
import NetworkRequirementsComponent from "@/app/views/networkRequirements/networkRequirements.component.vue";
import BanUserComponent from "@/app/components/modals/banUser/banUser.component.vue";
import SendEmailComponent from "@/app/views/confirmInvitation/sendEmail.component.vue";
import SpacesListComponent from "@/app/admin/components/space/spacesList.component.vue";
import ManageUsersComponent from "@/app/components/manageSpace/components/users/manageUsers.component.vue";
import RequestSpacesComponent from "@/app/admin/components/requestSpaces.component/requestSpaces.component.vue";
import NewSpaceComponent from "@/app/admin/components/newSpace/newSpace.component.vue";
import DashboardComponent from "@/app/admin/components/dashboard/dashboard.component.vue";
import SuperSpaceListComponent from "../app/admin/components/space/superSpaceList.component.vue";
import GoodByeComponent from "../app/views/goodbye/goodbye.component.vue";
import { URL_CHECK } from "@/resources/constants/urlCheck";
import { i18n } from "@/resources/locales";
import AutoLoginMicrosoftView from "@/app/views/autoLoginMicrosoft/autoLoginMicrosoftView.vue";
import ActivateRegistration from "@/app/views/activeRegistration/activateRegistration.components.vue";
import Education from "@/app/views/hawkings/hawkingsView.vue";
import GicarAuthCallback from "@/app/views/authGicar/gicarAuthCallback.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: "/auth/login",
  },
  {
    path: "/register",
    name: "auth-register",
    component: RegisterComponent,
  },
  {
    path: "/login-microsoft",
    name: "auto-login-microsoft-view",
    component: AutoLoginMicrosoftView,
  },
  {
    path: "/active-space",
    name: "active-space-view",
    component: ActiveSpaceView,
  },
  {
    path: "/active-user",
    name: "active-user-view",
    component: ActivateUser,
  },
  {
    path: "/active-guest",
    name: "invitation-view",
    component: ConfirmInvitationView,
  },
  {
    path: "/registration/active-user",
    name: "active-registration",
    component: ActivateRegistration,
  },
  {
    path: "/good-bye",
    name: "good-bye-view",
    component: GoodByeComponent,
  },
  {
    path: "/invitation/:type/:token/:space",
    name: "invitation-view",
    component: ConfirmInvitationView,
  },
  {
    path: "/chrome-exclusive",
    name: "chrome-exclusive",
    component: ChromeExclusiveComponent,
  },
  {
    path: "/send-confirmation",
    name: "send-confirmation",
    component: SendEmailComponent,
  },
  {
    path: "/network-requirements",
    name: "network-requirements",
    component: NetworkRequirementsComponent,
  },
  {
    path: "/auth",
    name: "auth-view",
    component: AuthView,
    children: [
      {
        path: "login",
        name: "auth-login",
        component: LoginComponent,
      },
      {
        path: "forgot",
        name: "auth-forgot",
        component: ForgotPasswordComponent,
      },
      {
        path: "pin",
        name: "auth-pin",
        component: PinAcessComponent,
      },
      {
        path: "pin",
        name: "auth-pin-login",
        component: PinLoginComponent,
      },
      {
        path: "reset-password",
        name: "reset-password",
        component: ResetPasswordComponent,
      },
      {
        path: "gicar/callback",
        name: "gicar-auth-callback",
        component: GicarAuthCallback,
      },
    ],
  },
  {
    path: "/admin",
    name: "admin-view",
    redirect: { name: "dashboard" },
    component: AdminView,
    meta: {
      authorize: [ROLE_SUPER_ADMIN],
    },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: DashboardComponent,
        meta: {
          authorize: [ROLE_SUPER_ADMIN],
        },
      },
      {
        path: "multi_spaces",
        name: "multi_spaces",
        component: SuperSpaceListComponent,
        meta: {
          authorize: [ROLE_SUPER_ADMIN],
        },
      },
      {
        path: "spaces/:id",
        name: "spaces",
        component: SpacesListComponent,
        meta: {
          authorize: [ROLE_SUPER_ADMIN],
        },
      },
      {
        path: "spaces_requests",
        name: "spaces_requests",
        component: RequestSpacesComponent,
        meta: {
          authorize: [ROLE_SUPER_ADMIN],
        },
      },
      {
        path: "users",
        name: "users_list",
        component: ManageUsersComponent,
        meta: {
          authorize: [ROLE_SUPER_ADMIN],
        },
      },
      {
        path: "new_space",
        name: "new_space",
        component: NewSpaceComponent,
        meta: {
          authorize: [ROLE_SUPER_ADMIN],
        },
      },
    ],
  },
  {
    path: "/quickstart",
    name: "nubii-container",
    component: NubiiView,
    meta: {
      authorize: [ROLE_USER, ROLE_ADMIN],
    },
  },
  {
    path: "/main",
    name: "hawkings-container",
    component: Education,
    meta: {
      authorize: [ROLE_USER, ROLE_ADMIN],
    },
  },
  {
    path: "/ban",
    name: "ban",
    component: BanUserComponent,
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const roles = localStorage.getItem("roles");
  const deviceType = localStorage.getItem("deviceType");
  const { authorize } = to.meta;
  const isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isFirefox = /^((?!chrome|android).)*firefox/i.test(navigator.userAgent);
  if (process.env.VUE_APP_ENVIRONMENT != "PRO")
    console.log(
      deviceType,
      checkBrowser() && (!deviceType || deviceType !== "TABLET"),
      " Chrome ", isChrome,
      " Safari ", isSafari,
      " Firefox ", isFirefox
    );
  //DEVICES  
  const deviceIphone = "iphone";
  const deviceIpad = "ipad";
  const deviceAndroid = "android";
  const deviceTablet = "tablet";
  const mobile = "mobile";
  const mobi = "mobi";
  const uagent = navigator.userAgent.toLowerCase();
  if (process.env.VUE_APP_ENVIRONMENT != "PRO")
    console.log("///////// ",
      "Iplone ", (uagent.search(deviceIphone) > -1) ? true : false,
      "Ipad ", (uagent.search(deviceIpad) > -1) ? true : false,
      "Android ", (uagent.search(deviceAndroid) > -1) ? true : false,
      "Tablet ", (uagent.search(deviceTablet) > -1) ? true : false,
      "Movile ", (uagent.search(mobile) > -1) ? true : false,
      "Mobi ", (uagent.search(mobi) > -1) ? true : false,
    );
  /////////////////////////////////
  let jsonEducation = require("../assets/education/favicon.png");
  if (window.location.host.includes("hawkings.education")) {
      document.title = 'hawkings.education';
      let favicon = document.querySelector('link[rel="icon"]');
      favicon.setAttribute("href", jsonEducation);
  } else {
    document.title = 'nubi.city';
  }
  if (
    !to.matched.some((match) => match.path.includes("/chrome-exclusive")) &&
    (checkBrowser() || (!isChrome && !isSafari && !isFirefox)) &&
    (!deviceType || deviceType !== "TABLET")
  ) {
    return next("/chrome-exclusive");
  }
  if (authorize) {
    if (!token) {
      return next({ path: "/" });
    }
    if (
      authorize.length > 0 &&
      !authorize.some((r) => roles.split(",").includes(r))
    ) {
      return next({ path: "/" });
    }
  }
  if (to.matched.some((match) => match.path.includes("/auth")) && token) {
    if (roles.includes(ROLE_SUPER_ADMIN)) {
      return next("/admin");
    }
    else {
      let single = localStorage.getItem("single");
      if (single && single == "true") {
        return next("/main");
      }
      else {
        return next("/quickstart");
      }
    }
  }
  if (to.matched.some((match) => match.path.includes("/quickstart")) && token) {
    let single = localStorage.getItem("single");
    if (single && single == "true") {
      return next("/main");
    }
  }
  //TODO LOAD SPACE ACCORDING TO URL
  URL_CHECK.forEach(element => {
    let check = localStorage.getItem(element.check);
    if (element.id !== "0") {
      if ((window.location.host.includes(element.url) && !window.location.pathname.includes("invitation")) && (check === null || (check && check == "false"))) {
        localStorage.setItem("city", "OFF");
        localStorage.setItem("space_default", element.id);
        localStorage.setItem(element.check, "true");
      } else if (window.location.host.includes(element.url) && window.location.pathname.includes("invitation"))
        localStorage.setItem(element.check, "true");
    }
  });
  //---------------------------------
  next();
});
const checkBrowser = () => {
  console.log(
    navigator.userAgent,
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  );
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};
export default router;
